<template>
  <div>
    <b-row>
      <b-col>
        <c-input
          inputType="text"
          inputId="firstName"
          lableText="First Name"
          v-model="authentication.firstName"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <c-input
          inputType="text"
          inputId="lastName"
          lableText="Last Name"
          v-model="authentication.lastName"
        />
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col>
        <c-tel-input v-model="authentication.phone" class="m-0" />
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <c-input inputType="email" inputId="email" lableText="Email" v-model="authentication.email" />
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <c-input
          inputType="text"
          inputId="username"
          lableText="User Name"
          v-model="authentication.userName"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <c-input
          inputType="password"
          inputId="pwd"
          lableText="Password"
          v-model="authentication.password"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <c-input
          inputType="password"
          inputId="cpwd"
          lableText="Confirm Password"
          v-model="authentication.confirmpassword"
        />
      </b-col>
    </b-row>

    <slot name="footer-button" :data="authentication"></slot>
  </div>
</template>
<script>
import cInput from "@/components/FormElements/CustomInput";
import cTelInput from "@/components/FormElements/MobileNumberInput";
import ebSelect from "@/components/FormElements/Select";

export default {
  name: "Authentication",
  data() {
    return {
      authentication: {
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        userName: "",
        password: "",
        confirmpassword: ""
      }
    };
  },
  components: {
    cInput,
    cTelInput,
    ebSelect
  },
  methods: {},
  mounted() {}
};
</script>
<style scoped>
[btn-color="primary"] {
  height: 41px;
  background-color: #727cf5;
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: 'Lato';
  color: white;
  border: 0px;
  border-radius: 0px;
}

[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: 'Lato';
  border-radius: 0px;
  height: 43px;
  width: 139px;
  background-color: #727cf5;
  color: white;
}
.sqanswer {
  margin-top: -12px !important;
}
</style>
